




import {Component, Prop, Vue} from "vue-property-decorator";
import {MainPageConfig} from "@/interfaces/main-page.interface";
import {localStorageService} from "@/services/local-storage.service";
import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";

@Component({})
export default class Keyword extends Vue {
  @Prop() keyword: MainPageConfig.IKeyWord;

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  async onWordClick() {
    if (this.isKiosk) {
      top.postMessage({ action: 'set-keyword', payload: {
        id: this.keyword.entity_id,
        value: this.keyword.keyword
      } }, window.location.origin)
      return
    }

    localStorageService.pushHistory(
        {
          type: LocalStorageServiceConfig.HistoryItemTypes.KEYWORD,
          keyword: {
            entity_id: this.keyword.entity_id,
            keyword: this.keyword.keyword,
          },
        }
    );

    await this.$store.dispatch('rhizome/openRhizomeWithKeyword', {
      keyword: {
        id: Number(this.keyword.entity_id),
        value: this.keyword.keyword,
      }
    });
  }
}
